module.exports = {
  email: 'vms1995@hotmail.com',

  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/Vikms95',
    },

    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/v%C3%ADctor-mart%C3%ADn-serra-b4003487/',
    },
  ],

  navLinks: [
    {
      name: 'Tecnologías',
      url: '/#about',
    },
    {
      name: 'Experiencia',
      url: '/#jobs',
    },
    {
      name: 'Proyectos',
      url: '/#projects',
    },
    {
      name: 'Contacto',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
